import axios from 'axios';
import { checkTokenHeaders } from '../apiHelper'
import { Request, req } from '../Repository';

const resource = '/hcf'
export default {
    getHcfText: token => {
        return req(token).then(token => {
            return Request.get(`${resource}/gethcfinfo`, token);
        })
    },
    getHcfCodelist: token => {
        return req(token).then(token => {
            return Request.get(`${resource}/codelist`, token);
        })
    },
    sendHcf: (model, token) => {
        return req(token).then(token => {
            return Request.post(`${resource}/contract`, JSON.stringify(model), token);
        })
    },
    getStreetHint: (model, token) => {
        return req(token).then(token => {
            return Request.post(`${resource}/findavailableaddresses`, JSON.stringify(model), token);
        })
    }

}
